export default {"src":"/_next/static/media/verify.ddc290f1.svg","height":38,"width":40,"blurWidth":0,"blurHeight":0};